import { render, staticRenderFns } from "./OrganDetailCompany.vue?vue&type=template&id=11df9f40&scoped=true"
import script from "./OrganDetailCompany.vue?vue&type=script&lang=js"
export * from "./OrganDetailCompany.vue?vue&type=script&lang=js"
import style0 from "./OrganDetailCompany.vue?vue&type=style&index=0&id=11df9f40&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11df9f40",
  null
  
)

export default component.exports